/**
 * TODO: infinite scroll logic
 * TODO!: preserve searchBar text after navigating to a searched plot
 */

import React, { useEffect, useState } from "react";
import { TPlot } from "stencil-library";
import { fetchUserPlots, getOrgSegment, getUserInfo } from "../../services/user.service";
import { useNavigate } from "react-router-dom";
import { Routes } from "../../routes";
import {PlotCard, SearchBar} from "./component";
import "./home.css";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { languageAtom } from "../../state/atoms/language.atom";
import { FylloHeader } from "react-library";
import { t } from "../../services/locale.service";
import { APIOptions } from "../../services/common.service";
import { userData } from "../../state/atoms/global.atom";
import { TStatusState } from "../../types";

export const TestIds = {
  onboardingLoader: "onboarding-loading",
  unauthorizedScreen: "unauthorized-testid",
  noPlotScreen: "noplot-testid",
  searchedPlotNotFound: "searched-plot-notfound",
  searchBar: "plot-search-bar",
  plotsContainer: "plot-container",
  searchedPlotsContainer: "searched-plots-container"
};

export const UNAUTHORIZED_ERROR = "UnauthorizedError";

const Home: React.FC = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const plotId = queryParams.get("plotId");
  const redirectScreenName = queryParams.get("redirectScreenName");

  const isOldUiDisabled = true;

  const setUserData = useSetRecoilState(userData);
  const curUserData = useRecoilValue(userData);

  const [status, setStatus] = useState<TStatusState>({ type: "loading", message: "Getting your details..." });

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [plots, setPlots] = useState<Array<TPlot>>([]);

  const [showSearchedPlots, setShowSearchedPlots] = useState<boolean>(false);
  const [searchedPlots, setSearchedPlots] = useState<Array<TPlot>>([]);

  const [selectedLanguage, setSelectedLanguage] = useRecoilState(languageAtom);
  const [userUpdatedLanguage, setUserUpdatedLanguage] = useState<boolean>(false);

  const navigate = useNavigate();


  const fetchPlots = async () => {
    return;
    try {
      setIsLoading(true);
      const plots = await fetchUserPlots({}, { skip: 0, limit: 20 });
      setPlots(plots);
    } catch(error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const searchPlot = async (searchText = "") => {
    if (!searchText || searchText.length === 0 && !isLoading) {
      setShowSearchedPlots(false);
    }

    if(searchText.length < 3) {
      return;
    }

    try {
      setIsLoading(true);
      const searchedPlots = await fetchUserPlots({ searchText }, {skip: 0, limit: 20});
    
      setSearchedPlots(searchedPlots);
      setShowSearchedPlots(true);
    } catch(error) {
      console.error("search plot", error);
    } finally {
      setIsLoading(false);
    }
  };

  const searchedPlotNotFound = !isLoading && showSearchedPlots && searchedPlots?.length === 0;

  const updateLang = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    setUserUpdatedLanguage(true);
    if(selectedLanguage === "en") {
      setSelectedLanguage("hi");
    } else {
      setSelectedLanguage("en");
    }
  };

  const fetchUserInfo = async() => {
    try {
      const options : APIOptions= {
        basePath: "https://dashboard.fyllo.in/api",
        sendTokenInUrl: true
      };
      const url = "/farmusers/getfarmuserData";
      const res = await getUserInfo(url, options);
      if (res && res?.farmUserId) {
        localStorage.setItem("farmUserId", res.farmUserId);
      }
      setUserData(res);
    } catch (error) {
      console.log(error);
      setStatus({ type: "error", message: t("Something_went_wrong") });
    }
  };

  const handleRedirectFromParams = (sectionId: string | undefined) => {
    try {
      const orgId = getOrgSegment(curUserData);
      if(plotId && orgId){
        switch (sectionId) {
        case ScreenId.CropStage:
          navigate(Routes.orgCropStageDetails.replace(":plotId", plotId).replace(":orgId", orgId));
          break;

        case ScreenId.SensorData:
          navigate(Routes.sensors.replace(":plotId", plotId).replace(":orgId", orgId));
          break;

        case ScreenId.SprayData:
          navigate(Routes.orgSpray.replace(":plotId", plotId).replace(":orgId", orgId));
          break;
        
        case ScreenId.DiseaseSensorData:
          navigate(Routes.diseaseSensors.replace(":plotId", plotId).replace(":orgId", orgId));
          break;
        
        case ScreenId.PestSensorData:
          navigate(Routes.pestSensors.replace(":plotId", plotId).replace(":orgId", orgId));
          break;
            
        case ScreenId.Fertigation:
          navigate(Routes.orgFertigation.replace(":plotId", plotId).replace(":orgId", orgId));
          break;
        
        case ScreenId.Calendar:
          navigate(Routes.calendar.replace(":plotId", plotId).replace(":orgId", orgId));
          break;
        
        case ScreenId.Others:
          navigate(Routes.others.replace(":plotId", plotId).replace(":orgId", orgId));
          break;
        default:
          navigate(Routes.home);
          break;
        }
      }
    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    fetchUserInfo();
    fetchPlots();
  }, []);

  useEffect(() => {
    if(curUserData){
      // A failed profile request leaves its error body here, so only a loaded user (it has a
      // farmUserId) gets in. Users without an organization use the default org segment.
      if(curUserData?.farmUserId){
        setStatus({ type: "success", message: "Success!" });
        if(plotId && redirectScreenName){
          handleRedirectFromParams(redirectScreenName); //Handles redirection to a specific screen from query params
        }
        else{
          navigate(Routes.orgHome.replace(":orgId", getOrgSegment(curUserData)));
        }
      }
      else{
        setStatus({ type: "error", message: "Not able to load your details." });
      }
    }
  }, [curUserData]);

  curUserData;
  useEffect(() => {
    if(!isLoading && plots?.length === 0) {
      navigate(Routes.noPlot);
    }
  }, [plots]);

  useEffect(() => {
    if(userUpdatedLanguage) {
      navigate(Routes.unauthorized);
    }
  }, [selectedLanguage]);

  return (
    <div style={{ overflowX: "hidden", padding: 10 }}>
      <p style={{textAlign: "center"}}>{status.message}</p>
      {
        isOldUiDisabled  ?
          <></>
          :  <>
            <FylloHeader headerTitle={t("Plots")} />
            <div className="toggle-language-container">
              <button onClick={updateLang} className="toggle-language-button">
                {t("Language")}: {selectedLanguage}
              </button>
            </div>

            <SearchBar onTextChange={searchPlot} />

            {isLoading && (
              <div
                data-testid={TestIds.onboardingLoader}
                style={{ overflowX: "hidden", padding: 10 }}
              >
                {t("Loading")}
              </div>
            )}

            {searchedPlotNotFound && (
              <div data-testid={TestIds.searchedPlotNotFound} className="no-plot-found-containerno-plot-found-container">
                <p className="no-plot-found-text" >{t("No_plots_found")}</p>
              </div>
            )}


            <div data-testid={ showSearchedPlots ? TestIds.searchedPlotsContainer : TestIds.plotsContainer }>
              {(showSearchedPlots ? searchedPlots : plots)?.map((plot, index) => (
                <PlotCard lang={selectedLanguage} key={`plot-card-${index}-${plot.plotId}`} plot={plot} />
              ))}
            </div></>
      }

    </div>
  );
};

export default Home;

/**
 * Enums
 */

export enum ScreenId {
  CropStage = "cropStage",
  SensorData = "sensorData",
  SprayData = "sprayData",
  DiseaseSensorData = "diseaseSensorData",
  PestSensorData = "pestSensorData",
  Fertigation = "fertigation",
  Calendar = "calendar",
  Others = "others"
}